module.exports = __webpack_public_path__ + "static/20-d457048242c1f4deabbe5bf87d0725af.jpg";